import React, { useRef, useState, useEffect } from 'react'
import styles from './BotEntry.module.css'
import classNames from 'classnames'
import { Button, message, Typography } from 'antd'
import { useDispatch } from 'react-redux'
import botIcon from './botIcon.svg'
const { Text } = Typography
export default function BotEntry(props) {
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    return () => {}
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <div className={styles.background} onClick={props.goToMethod}>
      <div className={styles.leftContent}>
        <div className={styles.title}>基础智能体管理</div>
        <div className={styles.description}>无需编程，创建属于你的AI应用！</div>
        <Button className={styles.tryButton} type="primary">现在就尝试一下→</Button>
      </div>
      <img src={botIcon} alt="bot" className={styles.rightIcon} />
    </div>
  )
}
